export default __webpack_public_path__ + "static/media/nodejsLogo.3759f131.webp";